// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__2oS11","content":"LayoutSettings_content__2fCah"};